import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import toast from "react-hot-toast";
import * as yup from "yup";
import TextInput from "../../../../components/form/text-input";
import Modal from "../../../../components/modal";
import Button from "../../../../components/new-button";
import Select from "../../../../components/form/select";
import TagInput from "../../../../components/form/tag-input";
import PlusIcon from "../../../../assets/svg/icons/common/Plus";
import FancyRadioInput from "../../../../components/form/fancy-radio-input";
import Collapsible from "../../../../components/collapsible";
import FancyCheckBox from "../../../../components/form/fancy-checkbox";
import Switch from "../../../../components/form/switch";
import baseStyles from "../base.module.scss";
import {
  saveUpdateEquipments,
  getEquipmentBrand,
  getEquipmentCategory,
  getEquipmentsV2,
  getActiveBanks,
} from "../../../../../api";
import ImageCropper from "../../../../components/image-cropper";
import ImageUpload from "../../../../components/image-upload";
import SlidingToggle from "../../../../components/form/sliding-checkbox";
import CloseIcon from "../../../../assets/svg/icons/common/CloseIcon";
import { EmsBootSection } from "./ems-boot-section";
import { fetchBrands, fetchModels } from "../../../../stores/equipment";

const schema = yup.object({
  equipment_name: yup.string().trim().required("* Equipment name is required"),
  equipment_type: yup.string().trim().required("* Equipment type is required"),
});

const ems_data = {
  monthly_fee: false,
  monthly_fee_default: "25.00",
  per_transaction: false,
  per_transaction_default: "0.10",
  purchase_for: false,
  purchase_for_default: "230.00",
  rent_for: false,
  rent_for_default: "20.00",
  apply_tpp: false,
  apply_tpp_default: "yes",
  sass_fee: false,
  sass_fee_default: "230.00",
  lease_for: false,
  lease_for_default: "20.00",
  amount: false,
  amount_default: "25.00",
  factor_rate: false,
  factor_rate_default: "0.10",
  payback: false,
  payback_default: "0.10",
  sim_card: false,
  sim_card_monthly_default: "0.05",

  hardware: false,
  hardware_default: "",
  file_types: false,
  file_types_default: "",
  package: false,
  package_default: "",
  other_equipment: false,
  other_equipments_default: "",
  pin_debit: false,
  cable_length: false,
  cable_length_default: "",
  customer_facing: false,
  virtual_terminal: false,
  monthly_wireless: false,
  monthly_wireless_default: "0.10",
  text_sms_fee: false,
  text_sms_fee_default: "0.10",
  promotion_text: "",
  connectivity: false,
  connectivity_options: "",
  connectivity_default: "sim",
  monthly_cellular_txn: false,
  cellular_per_txn: false,
  monthly_cellular_txn_default: "25",
  cellular_per_txn_default: "0.10",
};

export const AddEquipmentModal = ({
  open,
  onClose,
  isEdit = false,
  activeModel = null,
  brandId = null,
}) => {
  const [imageCropDialogOpen, setImageCropDialogOpen] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [imageToShow, setImageToShow] = useState(null);
  const [croppedImageBlob, setCroppedImageBlob] = useState(null);
  const [croppedImageFileName, setCroppedImageFileName] = useState(null);
  const [equipments, setEquipments] = useState([]);
  const [equipmentLoading, setEquipmentLoading] = useState(true);
  const [equipmentBrands, setEquipmentBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [processorOptions, setProcessorOptions] = useState([]);

  const getInitialValues = () => {
    if (isEdit && activeModel) {
      return {
        equipment_name: activeModel.equipment_name || "",
        equipment_type: activeModel.equipment_type || "terminal",
        equipment_image: null,
        equipment_pdf: null,
        description:
          activeModel.description === "null"
            ? ""
            : activeModel.description || "",
        free_text:
          activeModel.free_text === "null" ? "" : activeModel.free_text || "",
        is_ems_boot: activeModel.is_ems_boot == 1 ? "yes" : "no",
        ems_boot_data: {
          monthly_fee: activeModel?.monthly_fee == 1 ? true : false,
          monthly_fee_default: activeModel?.monthly_fee_default
            ? activeModel?.monthly_fee_default
            : "25.00",
          per_transaction: activeModel?.per_transaction == 1 ? true : false,
          per_transaction_default: activeModel?.per_transaction_default
            ? activeModel?.per_transaction_default
            : "0.10",
          purchase_for: activeModel?.purchase_for == 1 ? true : false,
          purchase_for_default: activeModel?.purchase_for_default
            ? activeModel?.purchase_for_default
            : "230.00",
          rent_for: activeModel?.rent_for == 1 ? true : false,
          rent_for_default: activeModel?.rent_for_default
            ? activeModel?.rent_for_default
            : "20.00",
          apply_tpp: activeModel?.apply_tpp == 1 ? true : false,
          apply_tpp_default: activeModel?.apply_tpp_default
            ? activeModel?.apply_tpp_default
            : "yes",
          sass_fee: activeModel?.sass_fee == 1 ? true : false,
          sass_fee_default: activeModel?.sass_fee_default
            ? activeModel?.sass_fee_default
            : "230.00",
          lease_for: activeModel?.lease_for == 1 ? true : false,
          lease_for_default: activeModel?.lease_for_default
            ? activeModel?.lease_for_default
            : "20.00",
          amount: activeModel?.amount == 1 ? true : false,
          amount_default: activeModel?.amount_default
            ? activeModel?.amount_default
            : "25.00",
          factor_rate: activeModel?.factor_rate == 1 ? true : false,
          factor_rate_default: activeModel?.factor_rate_default
            ? activeModel?.factor_rate_default
            : "0.10",
          payback: activeModel?.payback == 1 ? true : false,
          payback_default: activeModel?.payback_default
            ? activeModel?.payback_default
            : "0.10",
          sim_card: activeModel?.sim_card == 1 ? true : false,
          sim_card_monthly_default: activeModel?.sim_card_monthly_default
            ? activeModel?.sim_card_monthly_default
            : "0.05",

          hardware: activeModel?.hardware == 1 ? true : false,
          hardware_default:
            activeModel?.hardware_default != null
              ? activeModel?.hardware_default
              : "",
          file_types: activeModel?.file_types == 1 ? true : false,
          file_types_default:
            activeModel?.file_types_default != null
              ? activeModel?.file_types_default
              : "",
          package: activeModel?.package == 1 ? true : false,
          package_default:
            activeModel?.package_default != null
              ? activeModel?.package_default
              : "",
          other_equipments: activeModel?.other_equipments == 1 ? true : false,
          other_equipments_default:
            activeModel?.other_equipments_default != null
              ? activeModel?.other_equipments_default
              : "",
          customer_facing: activeModel?.customer_facing == 1 ? true : false,

          pin_pad: activeModel?.pin_pad == 1 ? true : false,
          pin_pad_name_default: activeModel?.pin_pad_name_default ?? "",
          monthly_wireless: activeModel?.monthly_wireless == 1 ? true : false,
          monthly_wireless_default: activeModel?.monthly_wireless_default
            ? activeModel?.monthly_wireless_default
            : "0.10",
          virtual_terminal: activeModel?.virtual_terminal == 1 ? true : false,
          text_sms_fee: activeModel?.text_sms_fee == 1 ? true : false,
          text_sms_fee_default: activeModel?.text_sms_fee_default
            ? activeModel?.text_sms_fee_default
            : "0.10",
          pin_debit: activeModel?.pin_debit == "1" ? true : false,
          cable_length: activeModel?.cable_length == "1" ? true : false,
          cable_length_default: activeModel?.cable_length_default || "",
          promotion_text: activeModel?.promotion_text || "",

          connectivity: activeModel?.connectivity == 1 ? true : false,
          connectivity_default: activeModel?.connectivity_default || "",
          connectivity_options: activeModel?.connectivity_options || "",

          monthly_cellular_txn:
            activeModel?.monthly_cellular_txn == 1 ? true : false,
          cellular_per_txn: activeModel?.cellular_per_txn == 1 ? true : false,
          monthly_cellular_txn_default:
            activeModel?.monthly_cellular_txn_default != null
              ? activeModel?.monthly_cellular_txn_default
              : ems_data.monthly_cellular_txn_default,
          cellular_per_txn_default:
            activeModel?.cellular_per_txn_default != null
              ? activeModel?.cellular_per_txn_default
              : ems_data.cellular_per_txn_default,

          add_on_equipment: activeModel?.add_on_equipment == 1 ? true : false,
          add_on_equipment_options:
            activeModel?.add_on_equipment_options?.join(",") ?? "",

          equipment_for_nuvie:
            activeModel?.equipment_for_nuvie == 1 ? true : false,
          nuvie_equipment_name: activeModel?.nuvie_equipment_name || "",
        },
        category: activeModel.category_id || "",
        brand_id: activeModel.brand_id || "",
        processors: (activeModel.processors || []).map(Number),
        feature_points:
          (activeModel?.feature_points &&
            Object.entries(JSON.parse(activeModel?.feature_points || "{}")).map(
              ([key, value]) => value,
            )) ||
          [],
      };
    }

    return {
      equipment_name: "",
      equipment_type: "terminal",
      equipment_image: null,
      equipment_pdf: null,
      description: "",
      free_text: "",
      is_ems_boot: "no",
      ems_boot_data: {
        monthly_fee: false,
        monthly_fee_default: "25.00",
        per_transaction: false,
        per_transaction_default: "0.10",
        purchase_for: false,
        purchase_for_default: "230.00",
        rent_for: false,
        rent_for_default: "20.00",
        apply_tpp: false,
        apply_tpp_default: "yes",
        sass_fee: false,
        sass_fee_default: "230.00",
        lease_for: false,
        lease_for_default: "20.00",
        amount: false,
        amount_default: "25.00",
        factor_rate: false,
        factor_rate_default: "0.10",
        payback: false,
        payback_default: "0.10",
        sim_card: false,
        sim_card_monthly_default: "0.05",

        hardware: false,
        hardware_default: "",
        file_types: false,
        file_types_default: "",
        package: false,
        package_default: "",
        other_equipments: false,
        other_equipments_default: "",
        customer_facing: false,

        pin_pad: false,
        pin_pad_name_default: "",
        monthly_wireless: false,
        monthly_wireless_default: "0.10",
        virtual_terminal: false,
        text_sms_fee: false,
        text_sms_fee_default: "0.10",
        pin_debit: false,
        cable_length: false,
        cable_length_default: "",
        promotion_text: "",

        connectivity: false,
        connectivity_default: "",
        connectivity_options: "",

        monthly_cellular_txn: false,
        cellular_per_txn: false,
        monthly_cellular_txn_default: ems_data.monthly_cellular_txn_default,
        cellular_per_txn_default: ems_data.cellular_per_txn_default,

        add_on_equipment: false,
        add_on_equipment_options: "",

        equipment_for_nuvie: false,
        nuvie_equipment_name: "",
      },
      category: "",
      brand_id: "",
      processors: [],
      dummy_feature_point: "",
      feature_points: [],
    };
  };

  useEffect(() => {
    const abortController = new AbortController();
    getEquipmentBrand({ all: "all" })
      .then((res) => {
        if (res.status && res.data.length > 0) {
          const brands = res.data.map((brand) => ({
            label: brand.name,
            value: brand.id,
          }));
          setEquipmentBrands(brands);
        }
      })
      .catch((err) => {
        console.error(err);
      });

    getEquipmentCategory(abortController)
      .then((res) => {
        if (res.status && res.data.length > 0) {
          const categories = res.data.map((cat) => ({
            label: cat.category,
            value: cat.id,
            category_type: cat.category_type,
          }));
          setCategories(categories);
        }
      })
      .catch((err) => {
        console.error(err);
      });

    getActiveBanks()
      .then((res) => {
        if (res.status && res.data?.length > 0) {
          setProcessorOptions(
            res.data.map((bank) => ({
              value: Number(bank.id),
              label: bank.name,
            })),
          );
        }
      })
      .catch((err) => {
        console.error(err);
      });

    getEquipmentsV2(
      {
        noCategorySplit: true,
      },
      abortController,
    )
      .then((res) => {
        if (res.status && res.data.length > 0) {
          setEquipments(res.data);
          setEquipmentLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const handleImageCrop = (file) => {
    setImageCropDialogOpen(true);
    setUploadedImage(URL.createObjectURL(file));
    setCroppedImageFileName(file.name);
  };

  const getCategoryOptions = (equipmentType) => {
    if (equipmentType === "terminal") {
      return categories
        .filter((cat) => cat.category_type === "terminal")
        .map((cat) => ({ label: cat.category, value: cat.id }));
    }
    if (equipmentType === "gateway") {
      return categories
        .filter((cat) => cat.category_type === "gateway")
        .map((cat) => ({ label: cat.category, value: cat.id }));
    }
    if (equipmentType === "add_on") {
      const terminals = categories
        .filter((cat) => cat.category_type === "terminal")
        .map((cat) => ({ label: cat.category, value: cat.id }));
      const gateways = categories
        .filter((cat) => cat.category_type === "gateway")
        .map((cat) => ({ label: cat.category, value: cat.id }));
      const addOns = categories
        .filter((cat) => cat.category_type === "add_on")
        .map((cat) => ({ label: cat.category, value: cat.id }));

      return [
        { label: "Terminals", options: terminals },
        { label: "Gateways", options: gateways },
        { label: "Add Ons", options: addOns },
      ];
    }
    return [];
  };

  const handleFormSubmit = async (values, { setSubmitting }) => {
    toast.loading(`${isEdit ? "Updating" : "Creating"} equipment...`);

    try {
      const formData = new FormData();

      if (croppedImageBlob) {
        formData.append(
          "equipment_image",
          croppedImageBlob,
          croppedImageFileName,
        );
      }

      if (values.equipment_pdf !== null) {
        formData.append(
          "equipment_pdf",
          values.equipment_pdf,
          values.equipment_pdf.name,
        );
      }

      formData.append("equipment_name", values.equipment_name);
      formData.append("equipment_type", values.equipment_type);
      formData.append("description", values.description);
      formData.append("free_text", values.free_text);
      formData.append("is_ems_boot", values.is_ems_boot);
      formData.append("category", values.category);
      formData.append("brand_id", values.brand_id);
      formData.append("processors", JSON.stringify(values.processors || []));
      formData.append("feature_points", JSON.stringify({}));

      if (values.feature_points.length > 0) {
        const featurePoints = values.feature_points.reduce(
          (acc, point, index) => {
            acc[`point_${index + 1}`] = point;
            return acc;
          },
          {},
        );

        formData.set("feature_points", JSON.stringify(featurePoints));
      }

      formData.append("ems_boot_data", JSON.stringify(values.ems_boot_data));

      if (isEdit && activeModel) {
        formData.append("id", activeModel.id);
      }

      const response = await saveUpdateEquipments(formData);
      toast.dismiss();

      if (response.status) {
        setSubmitting(false);
        toast.success(
          `Equipment ${isEdit ? "updated" : "created"} successfully,`,
        );

        if (brandId) {
          fetchModels(brandId);
        } else {
          fetchBrands();
        }

        onClose();
      } else {
        setSubmitting(false);
        toast.error(
          response.message ||
            `There was a problem ${isEdit ? "updating" : "creating"} equipment,`,
        );
      }
    } catch (error) {
      setSubmitting(false);
      toast.error(
        `There was a problem ${isEdit ? "updating" : "creating"} equipment,`,
      );
      console.error(
        `Error ${isEdit ? "updating" : "creating"} equipment:`,
        error,
      );
    }
  };

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      header={`${isEdit ? "Edit" : "Add"} Equipment`}
      notCentered
      size="lg"
    >
      <Formik
        enableReinitialize
        validationSchema={schema}
        onSubmit={handleFormSubmit}
        initialValues={getInitialValues()}
        validateOnBlur={false}
        validateOnChange={true}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          errors,
          setFieldValue,
          isSubmitting,
        }) => (
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className={`${baseStyles.grid} ${baseStyles.gap2}`}>
              <div
                className={`${baseStyles.grid} ${baseStyles.gridCols1} ${baseStyles.gap2}`}
              >
                <TextInput
                  label="Model"
                  id="equipment_name"
                  name="equipment_name"
                  placeholder="Enter equipment model"
                  value={values.equipment_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.equipment_name}
                  errored={errors.equipment_name}
                  error={errors.equipment_name}
                />

                <Select
                  label="Brand"
                  placeholder="Select brand"
                  id="brand_id"
                  name="brand_id"
                  options={equipmentBrands}
                  value={values.brand_id}
                  onChange={(option) => {
                    setFieldValue("brand_id", option);
                  }}
                />

                <TextInput
                  label="Promotion text (optional)"
                  id="ems_boot_data.promotion_text"
                  name="ems_boot_data.promotion_text"
                  placeholder="Enter promotion text"
                  value={values.ems_boot_data.promotion_text}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.ems_boot_data?.promotion_text}
                  errored={errors.ems_boot_data?.promotion_text}
                  error={errors.ems_boot_data?.promotion_text}
                />

                <div>
                  <label
                    className={`${baseStyles.label} ${baseStyles.labelLarge} ${baseStyles.labelNormal}`}
                  >
                    Type
                  </label>
                  <div className={`${baseStyles.flex} ${baseStyles.gap1}`}>
                    {[
                      {
                        label: "Terminal",
                        value: "terminal",
                      },
                      {
                        label: "Gateway",
                        value: "gateway",
                      },
                      {
                        label: "Add On",
                        value: "add_on",
                      },
                    ].map((item) => (
                      <FancyCheckBox
                        key={`equipment_type_${item.value}_checkbox`}
                        label={item.label}
                        id={`equipment_type_${item.value}`}
                        name="equipment_type"
                        value={item.value}
                        checked={values.equipment_type === item.value}
                        onChange={(e) => {
                          setFieldValue("equipment_type", e.target.value);
                          setFieldValue("category", "");
                        }}
                        touched={touched.equipment_type}
                        errored={errors.equipment_type}
                        error={errors.equipment_type}
                      />
                    ))}
                  </div>
                </div>

                {categories?.length > 0 && (
                  <Select
                    label="Category"
                    placeholder="Select category"
                    options={categories?.filter((cat) => {
                      if (values.equipment_type === "terminal") {
                        return cat.category_type === "terminal";
                      }

                      if (values.equipment_type === "gateway") {
                        return cat.category_type === "gateway";
                      }

                      return true;
                    })}
                    value={values.category}
                    onChange={(option) => {
                      setFieldValue("category", option);
                    }}
                  />
                )}

                <div>
                  <label
                    className={`${baseStyles.label} ${baseStyles.labelLarge} ${baseStyles.labelNormal}`}
                  >
                    Supported processors
                  </label>

                  {processorOptions.length > 0 && (
                    <TagInput
                      label="Processors"
                      id="processors"
                      placeholder="Search processors"
                      value={processorOptions.filter((option) =>
                        (values.processors || []).includes(option.value),
                      )}
                      options={processorOptions}
                      onChange={(selected) => {
                        setFieldValue(
                          "processors",
                          selected.map((processor) => processor.value),
                        );
                      }}
                    />
                  )}
                </div>

                <div>
                  <label
                    className={`${baseStyles.label} ${baseStyles.labelLarge} ${baseStyles.labelNormal}`}
                  >
                    Features
                  </label>

                  <div
                    className={`${baseStyles.flex} ${baseStyles.gap1} ${baseStyles.alignCenter}`}
                  >
                    <div
                      style={{
                        flex: 1,
                      }}
                    >
                      <TextInput
                        label="Feature text"
                        name="dummy_feature_point"
                        id="dummy_feature_point"
                        value={values.dummy_feature_point}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>
                    <div>
                      <label className={baseStyles.label}>&nbsp;</label>
                      <Button
                        type="button"
                        variant="primary"
                        onClick={() => {
                          setFieldValue("feature_points", [
                            ...values.feature_points,
                            values.dummy_feature_point,
                          ]);
                          setFieldValue("dummy_feature_point", "");
                        }}
                      >
                        <PlusIcon />
                      </Button>
                    </div>
                  </div>

                  {values.feature_points.length > 0 && (
                    <div
                      style={{
                        width: "100%",
                        height: "1px",
                        backgroundColor: "#ededf4",
                        margin: "1rem 0",
                      }}
                    ></div>
                  )}

                  {values.feature_points.length > 0 && (
                    <div
                      className={`${baseStyles.grid} ${baseStyles.gridCols1} ${baseStyles.gap2}`}
                    >
                      {values.feature_points.map((point, index) => (
                        <div
                          key={`feature_point_${index}`}
                          className={`${baseStyles.flex} ${baseStyles.gap1} ${baseStyles.alignCenter}`}
                        >
                          <div style={{ flex: 1 }}>
                            <TextInput
                              value={point}
                              id={`feature_point_${index}`}
                              name={`feature_points.${index}`}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </div>
                          <div>
                            <Button
                              type="button"
                              variant="secondary"
                              onClick={() => {
                                setFieldValue(
                                  "feature_points",
                                  values.feature_points.filter(
                                    (_, i) => i !== index,
                                  ),
                                );
                              }}
                            >
                              <CloseIcon />
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div>
                  <label className={baseStyles.label}>Image</label>
                  <ImageUpload
                    onImageSelect={(file) => {
                      handleImageCrop(file);
                    }}
                    onImageRemove={() => {
                      setCroppedImageBlob(null);
                      setCroppedImageFileName(null);
                      setImageToShow(null);
                    }}
                    currentImage={
                      imageToShow ||
                      (isEdit && activeModel
                        ? `/img-equipment/${activeModel.id}`
                        : null)
                    }
                    placeholder="Upload equipment image by drag and drop or click to upload"
                    subText="high quality image"
                    accept="image/*"
                    size="medium"
                  />
                </div>

                <div>
                  <label className={baseStyles.label}>PDF Document</label>
                  <input
                    type="file"
                    name="equipment_pdf"
                    accept=".pdf"
                    onChange={(e) => {
                      setFieldValue("equipment_pdf", e.target.files[0]);
                    }}
                    className="form-control"
                  />
                </div>

                <Collapsible defaultExpanded title="EMS Settings">
                  <div
                    className={`${baseStyles.grid} ${baseStyles.gridCols2} ${baseStyles.gap1}`}
                  >
                    <div>
                      <label
                        className={`${baseStyles.label} ${baseStyles.labelLarge} ${baseStyles.labelNormal}`}
                      >
                        Is EMS Boot
                      </label>
                      <SlidingToggle
                        name="is_ems_boot"
                        value={values.is_ems_boot}
                        onChange={(value) => {
                          setFieldValue("is_ems_boot", value);
                        }}
                        options={["yes", "no"]}
                        width="112px"
                      />
                    </div>
                  </div>

                  {values.is_ems_boot === "yes" ? (
                    <EmsBootSection
                      equipments={equipments}
                      equipmentLoading={equipmentLoading}
                    />
                  ) : (
                    ""
                  )}
                </Collapsible>

                <TextInput
                  label="Description"
                  name="description"
                  placeholder="Enter equipment description"
                  value={values.description}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.description}
                  errored={errors.description}
                  error={errors.description}
                />

                <TextInput
                  label="Free Text"
                  name="free_text"
                  placeholder="Enter free text"
                  value={values.free_text}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.free_text}
                  errored={errors.free_text}
                  error={errors.free_text}
                />
              </div>
            </div>

            <div className={`${baseStyles.grid} ${baseStyles.gap2}`}>
              <div
                className={`${baseStyles.flex} ${baseStyles.flexEnd} ${baseStyles.gap1}`}
                style={{ marginTop: "16px" }}
              >
                <Button type="button" variant="ghost" onClick={onClose}>
                  Cancel
                </Button>
                <Button type="submit" disabled={isSubmitting}>
                  {isEdit ? "Update" : "Add"}
                </Button>
              </div>
            </div>
          </form>
        )}
      </Formik>

      <ImageCropper
        open={imageCropDialogOpen}
        image={uploadedImage}
        onComplete={(croppedImage) => {
          fetch(croppedImage)
            .then((response) => response.blob())
            .then((blob) => {
              setCroppedImageBlob(blob);
              setImageToShow(croppedImage);
              setImageCropDialogOpen(false);
            });
        }}
        onClose={() => setImageCropDialogOpen(false)}
        aspect={1}
      />
    </Modal>
  );
};

export default AddEquipmentModal;
